export default __webpack_public_path__ + "static/media/ic_assign_2.6a76799f.png";